module.exports = __webpack_public_path__ + "static/media/summer.0ef81537.jpg";